// Utility functions for managing favorite properties

const FAVORITES_KEY = 'property_favorites';

// Get all favorite property IDs from localStorage
export const getFavorites = () => {
  try {
    const favorites = localStorage.getItem(FAVORITES_KEY);
    return favorites ? JSON.parse(favorites) : [];
  } catch (error) {
    console.error('Error reading favorites from localStorage:', error);
    return [];
  }
};

// Check if a property is favorited
export const isFavoriteProperty = (propertyId) => {
  if (!propertyId) return false;
  const favorites = getFavorites();
  return favorites.includes(propertyId);
};

// Add a property to favorites
export const addToFavorites = (propertyId) => {
  if (!propertyId) return;
  const favorites = getFavorites();
  if (!favorites.includes(propertyId)) {
    favorites.push(propertyId);
    try {
      localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    } catch (error) {
      console.error('Error saving favorites to localStorage:', error);
    }
  }
};

// Remove a property from favorites
export const removeFromFavorites = (propertyId) => {
  if (!propertyId) return;
  const favorites = getFavorites();
  const updatedFavorites = favorites.filter(id => id !== propertyId);
  try {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(updatedFavorites));
  } catch (error) {
    console.error('Error saving favorites to localStorage:', error);
  }
};

// Toggle favorite status for a property
export const toggleFavorite = (propertyId) => {
  if (!propertyId) return false;
  
  if (isFavoriteProperty(propertyId)) {
    removeFromFavorites(propertyId);
    return false;
  } else {
    addToFavorites(propertyId);
    return true;
  }
};